window.products = [];

window.setProducts = (data) => {
    window.products = data;
    window.products.forEach((x, i) => {
        if(x.id === "40001Tecalor_THZ") {
            window.products.splice(i, 1)
        }
    })
    window.products.forEach((x, i) => {
        if(x.id === "40011Podest") {
            window.products.splice(i, 1)
        }
    })

    console.log(window.products)
}

window.productsRoute = `${window.location.protocol}//${window.location.hostname}/api/products`;

window.focusObjects = [{
        "name": "10011Verteiler",
        "pos": {
            x: -0.6909751267167681,
            y: -1.3227016229881907,
            z: 3.29225916743427
        },
        "box": {
            x: -2.257240343093872,
            y: -1.979942363500595,
            z: 3.835445761680603
        }
    },
    {
        "name": "40001Tecalor_THZ",
        "pos": {
            x: -2.937261897487408,
            y: -0.7691377432620398,
            z: 1.3265294720365963
        }
    },
    {
        "name": "40011Podest",
        "pos": {
            x: -3.103555479626688,
            y: -1.5251964363457144,
            z: 6.825761919578168
        }
    },
    {
        "name": "10051Caleffi_Füllkombi",
        "pos": {
            x: -2.9161169092758428,
            y: -1.025273227769203,
            z: 2.4157977954848966
        }
    },
    {
        "name": "20071Geberit_Duofix_WC",
        "pos": {
            x: -2.0754664421850944,
            y: 1.7041964164447265,
            z: -3.3287940442369246
        },
        "box": {
            x: -4.29301538206636906,
            y: 1.2224788665771484,
            z: -3.9214285850524902
        }
    },
    {
        "name": "20061Geberit_Duofix_Waschtisch",
        "pos": {
            x: -1.8131089196524226,
            y: 1.9582522670263376,
            z: -2.8161738133926884
        }
    },
    {
        "name": "20101Hausanschluss",
        "pos": {
            x: -2.937261897487408,
            y: -0.7691377432620398,
            z: 1.3265294720365963
        }
    },
    {
        "name": "20091Sicherheitsgruppe",
        "pos": {
            x: -1.523833902687969,
            y: 0.03602550569180618,
            z: 3.9766686881247577
        },
        "box": {
            x: -2.570586290359497,
            y: -0.200520257949829,
            z: 4.171382427215576
        }
    },
    {
        "name": "20081Zirkulationspmumpe",
        "pos": {
            x: -3.0949940852036417,
            y: 0.10399204896261471,
            z: 3.200514464935735
        },
        "box": {
            x: -2.4975586290359497,
            y: -0.250520257949829,
            z: 3.941382427215576
        }
    },
    {
        "name": "10101Elco_Aerotop_Split_M",
        "pos": {
            x: -2.937261897487408,
            y: -0.7691377432620398,
            z: 1.3265294720365963
        }
    },
    {
        "name": "10111Podest",
        "pos": {
            x: -2.797007819229398, y: -2.5181490971694065, z: 6.669633927140945
        }
    },
    {
        "name": "10121Caleffi_Dirtmag",
        "pos": {
            x: -2.711385795346998, y: -0.5665346900165487, z: 2.3168574885051427
        }
    },
    {
        "name": "30041Pluggit_Avent_P310",
        "pos": {
            x: -2.579719127145651, y: -0.5845156868787387, z: 2.402173921948039
        }
    }
]

window.cameras = [{
        name: 'Haustechnik',
        id: 'cameratween0',
        pos: {
            x: -10,
            y: 6,
            z: 10
        },
        tar: {
            x: 0,
            y: 0,
            z: 0
        },
        obj: [
            "10000Fußbodenheizung",
            "10011Verteiler",
            "10020Rohrisolierung",
            "10030Heizungsrohre",
            "10040Ausdehnungsgefäß",
            "10051Caleffi_Füllkombi",
            "10060Randdämmstreifen",
            "10070Rollisolierung",
            "10080Zusatzisolierung",
            "10090Zusatzisolierung",
            "20010Frostsi",
            "20020Schutzschlauch",
            "20030Schmutzwasser",
            "20040Sanitär_Isolierung",
            "20050Sanitärrohre",
            "20061Geberit_Duofix_Waschtisch",
            "20071Geberit_Duofix_WC",
            "20081Zirkulationspmumpe",
            "20091Sicherheitsgruppe",
            "20101Hausanschluss",
            "30000Zuluft",
            "30010Abluft",
            "30020Außenluft",
            "30030Fortluft",
            "40001Tecalor_THZ",
            "40011Podest",
            "10101Elco_Aerotop_Split_M",
            "10111Podest",
            "10121Caleffi_Dirtmag",
            "30041Pluggit_Avent_P310"
        ]
    },
    {
        name: 'Holzständer',
        id: 'cameratween1',
        pos: {
            x: -10,
            y: 6,
            z: 10
        },
        tar: {
            x: 0,
            y: 0,
            z: 0
        },
        obj: [
            "00000Dachsparren",
            "00010Holzständer",
            "00020Fenster",
            "10000Fußbodenheizung",
            "10011Verteiler",
            "10020Rohrisolierung",
            "10030Heizungsrohre",
            "10040Ausdehnungsgefäß",
            "10051Caleffi_Füllkombi",
            "10060Randdämmstreifen",
            "10070Rollisolierung",
            "10080Zusatzisolierung",
            "10090Zusatzisolierung",
            "20010Frostsi",
            "20020Schutzschlauch",
            "20030Schmutzwasser",
            "20040Sanitär_Isolierung",
            "20050Sanitärrohre",
            "20061Geberit_Duofix_Waschtisch",
            "20071Geberit_Duofix_WC",
            "20081Zirkulationspmumpe",
            "20091Sicherheitsgruppe",
            "20101Hausanschluss",
            "30000Zuluft",
            "30010Abluft",
            "30020Außenluft",
            "30030Fortluft",
            "40001Tecalor_THZ",
            "40011Podest",
            "10101Elco_Aerotop_Split_M",
            "10111Podest",
            "10121Caleffi_Dirtmag",
            "30041Pluggit_Avent_P310"
        ]
    },
    {
        name: 'Grundinstallation',
        id: 'cameratween2',
        pos: {
            x: 0,
            y: 15,
            z: 0.1
        },
        tar: {
            x: 0,
            y: 0,
            z: 0
        },
        obj: [
            "00010Holzständer",
            "00020Fenster",
            "01000Außenputz",
            "01010Vollwärmeschutz",
            "01020Spanplatte",
            "01030Mineralwolle",
            "01040Dampfsperre",
            "02000Rigips",
            "02010Fermacell",
            "02020Mineralwolle",
            "03020Spahnplatte",
            "03030Mineralwolle",
            "03040Deckenverkleidung",
            "03050Bodenplatte",
            "10000Fußbodenheizung",
            "10011Verteiler",
            "10020Rohrisolierung",
            "10030Heizungsrohre",
            "10040Ausdehnungsgefäß",
            "10051Caleffi_Füllkombi",
            "10060Randdämmstreifen",
            "10070Rollisolierung",
            "10080Zusatzisolierung",
            "10090Zusatzisolierung",
            "20010Frostsi",
            "20020Schutzschlauch",
            "20030Schmutzwasser",
            "20040Sanitär_Isolierung",
            "20050Sanitärrohre",
            "20061Geberit_Duofix_Waschtisch",
            "20071Geberit_Duofix_WC",
            "20081Zirkulationspmumpe",
            "20091Sicherheitsgruppe",
            "20101Hausanschluss",
            "30000Zuluft",
            "30010Abluft",
            "30020Außenluft",
            "30030Fortluft",
            "40001Tecalor_THZ",
            "40011Podest",
            "10101Elco_Aerotop_Split_M",
            "10111Podest",
            "10121Caleffi_Dirtmag",
            "30041Pluggit_Avent_P310"
        ]
    },
    {
        name: 'Ausbauhaus',
        id: 'cameratween3',
        pos: {
            x: 11.37,
            y: 5.1,
            z: 9.32
        },
        tar: {
            x: 0,
            y: 0,
            z: 0
        },
        obj: [
            "00000Dachsparren",
            "00010Holzständer",
            "00020Fenster",
            "01000Außenputz",
            "01010Vollwärmeschutz",
            "01020Spanplatte",
            "03020Spahnplatte",
            "03050Bodenplatte",
            "04000Ziegel",
            "04010Konterlattung",
            "04020Unterspannbahn",
            "03020Spanplatte"
        ]
    },
    {
        name: 'Technikraum',
        id: 'cameratween4',
        pos: {
            x: -2.5199,
            y: -1.1965,
            z: 1.1765
        },
        tar: {
            x: -3.966911251339909,
            y: -1.75,
            z: 3.5810580226540867
        },
        obj: [
            "10000Fußbodenheizung",
            "10011Verteiler",
            "10020Rohrisolierung",
            "10030Heizungsrohre",
            "10040Ausdehnungsgefäß",
            "10051Caleffi_Füllkombi",
            "10060Randdämmstreifen",
            "10070Rollisolierung",
            "10080Zusatzisolierung",
            "10090Zusatzisolierung",
            "20010Frostsi",
            "20020Schutzschlauch",
            "20030Schmutzwasser",
            "20040Sanitär_Isolierung",
            "20050Sanitärrohre",
            "20061Geberit_Duofix_Waschtisch",
            "20071Geberit_Duofix_WC",
            "20081Zirkulationspmumpe",
            "20091Sicherheitsgruppe",
            "20101Hausanschluss",
            "30000Zuluft",
            "30010Abluft",
            "30020Außenluft",
            "30030Fortluft",
            "40001Tecalor_THZ",
            "40011Podest",
            "10101Elco_Aerotop_Split_M",
            "10111Podest",
            "10121Caleffi_Dirtmag",
            "30041Pluggit_Avent_P310"
        ]
    },
    {
        name: 'Wanddurchdringung',
        id: 'cameratween5',
        pos: {
            x: -1.1961377458483227,
            y: -0.5267510702488752,
            z: 1.080605842851537
        },
        tar: {
            x: -2.2972529121673626,
            y: -2.75,
            z: 0.07519214172226306
        },
        obj: [
            "00000Dachsparren",
            "00010Holzständer",
            "00020Fenster",
            "03050Bodenplatte",
            "30000Zuluft",
            "30010Abluft",
            "30020Außenluft",
            "30030Fortluft",
            "40001Tecalor_THZ",
            "40011Podest",
            "30041Pluggit_Avent_P310"
        ]
    }
]